import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Typography, Snackbar, Alert } from '@mui/material';
import FilledButton from './FilledButton';
import OutlinedButton from './OutlinedButton';
import api, { fetchDepartments } from '../services/api';

const AddDepartmentDialog = ({ open, onClose, onAdded, institutionId, onSuccess }) => {
  const [name, setName] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [exampleDept, setExampleDept] = useState('');
  const [departments, setDepartments] = useState([]);
  const [duplicate, setDuplicate] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    if (open) {
      fetchDepartments(institutionId)
        .then((res) => {
          setDepartments(res || []);
          setExampleDept(res?.[0]?.name || '');
        })
        .catch(() => {
          setExampleDept('');
          setDepartments([]);
        });
    }
  }, [open, institutionId]);

  useEffect(() => {
    if (open) {
      setName('');
      setDuplicate(false);
    }
  }, [open]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name) return;
    setSubmitting(true);
    try {
      const res = await api.post('/courses/departments/', { name, institution: institutionId });
      const refreshed = await fetchDepartments(institutionId);
      onAdded(refreshed);
      const msg = 'Department added';
      if (onSuccess) onSuccess(msg); else setSuccessMessage(msg);
      setName('');
      onClose();
    } catch (err) {
      console.error('Failed to add department:', err.response?.data || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" PaperProps={{ component: 'form', onSubmit: handleSubmit }}>
      <DialogTitle>Add Department</DialogTitle>
      <DialogContent sx={{ mt: 1 }}>
        <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
          Department Name <span style={{ color: 'red' }}>*</span>
        </Typography>
        <TextField
          autoFocus
          fullWidth
          value={name}
          onChange={(e) => {
            const val = e.target.value;
            setName(val);
            const lower = val.trim().toLowerCase();
            setDuplicate(
              lower && departments.some((d) => d.name.toLowerCase() === lower)
            );
          }}
          placeholder={exampleDept ? `e.g. ${exampleDept}` : ''}
          error={duplicate}
          helperText={duplicate ? 'Department with this name already exists.' : ''}
        />
      </DialogContent>
      <DialogActions>
        <OutlinedButton onClick={onClose} text="Cancel" color="info" />
        <FilledButton
          type="submit"
          disabled={submitting || !name || duplicate}
          text="Add"
          color="info"
        />
      </DialogActions>
    </Dialog>
    <Snackbar
      open={!!successMessage}
      autoHideDuration={3000}
      onClose={() => setSuccessMessage('')}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={() => setSuccessMessage('')} severity="success" sx={{ width: '100%', fontWeight: 'bold' }}>
        {successMessage}
      </Alert>
    </Snackbar>
    </>
  );
};

export default AddDepartmentDialog;
